<template>
  <div class="header-container">
    <div class="header-title" @click="toIndex()">
      <img
        src="https://huarong-img.oss-cn-beijing.aliyuncs.com/uploads/products/product_1769760703859_572784b830b26050.png"
        alt="Logo"
        class="header-logo"
      />
      <span class="title-text">联皓云管理系统</span>
    </div>

    <!-- 使用标签页组件 -->
    <Tabs />

    <div class="header-actions">
      <div class="download-center" @click="visible = !visible">
        <el-icon class="download-icon">
          <Downloadab />
        </el-icon>
        <span class="download-text">下载中心</span>
      </div>

      <!-- 商城切换器 -->
      <el-dropdown
        trigger="click"
        @visible-change="handleDropdownVisible"
        v-if="userStore.user.systemid == 2"
        ref="shopDropdown"
        popper-class="shop-dropdown-popper"
        v-permission="['headerselct']"
      >
        <div class="shop-trigger">
          <el-icon class="shop-icon"><Shop /></el-icon>
          <div class="shop-info">
            <div class="shop-name">{{ currentShopName }}</div>
          </div>
          <el-icon class="arrow-icon" :class="{ 'rotate': dropdownVisible }">
            <ArrowDown />
          </el-icon>
        </div>
        <template #dropdown>
          <el-dropdown-menu class="shop-dropdown-menu">
            <div class="shop-list-container">
              <el-dropdown-item
                v-for="shop in shopList"
                :key="shop.id"
                :class="{ 'active-shop': shop.id === currentShopId }"
                @click="handleSwitchShop(shop.id)"
              >
                <div class="shop-item">
                  <div class="shop-item-info">
                    <div class="shop-item-name">{{ shop.name }}</div>
                    <div class="shop-item-id">ID: {{ shop.id }}</div>
                  </div>
                  <el-icon v-if="shop.id === currentShopId" class="check-icon">
                    <Check />
                  </el-icon>
                </div>
              </el-dropdown-item>
            </div>
          </el-dropdown-menu>
        </template>
      </el-dropdown>

      <!-- 后台切换器 -->
      <el-dropdown
        trigger="click"
        class="admin-switcher"
        @command="handleAdminSwitch"
        v-permission="['headerselct']"
      >
        <div class="admin-trigger">
          <el-icon class="admin-icon"><Monitor /></el-icon>
          <span class="admin-name">{{ currentAdminName }}</span>
          <el-icon class="arrow-icon"><ArrowDown /></el-icon>
        </div>
        <template #dropdown>
          <el-dropdown-menu class="admin-dropdown-menu">
            <el-dropdown-item
              v-for="admin in adminList"
              :key="admin.id"
              :command="admin.id"
              :class="{ 'active-admin': admin.id === userStore.user.systemid }"
            >
              <div class="admin-item">
                <span>{{ admin.name }}</span>
                <el-icon v-if="admin.id === userStore.user.systemid" class="check-icon">
                  <Check />
                </el-icon>
              </div>
            </el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>

      <!-- 用户菜单 -->
      <el-dropdown class="user-dropdown" @command="handleCommand">
        <div class="user-trigger">
          <el-avatar :size="24" :src="userAvatar" class="user-avatar" />
          <span class="user-name">{{ nickname }}</span>
          <el-icon class="dropdown-icon"><ArrowDown /></el-icon>
        </div>
        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item @click="logout" divided>
              <el-icon @click="logout"><SwitchButton /></el-icon>退出登录
            </el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </div>
  </div>
  <a-modal v-model:visible="visible" title="下载中心" :width="1300" :body-style="{padding:'0'}" draggable>
    <File v-if="visible"/>
  </a-modal>
</template>

<script setup>
import {ref, computed, onMounted} from 'vue'
import { useRouter } from 'vue-router'
import { useUserStore } from '@/store/modules/user'
import { ElMessage } from 'element-plus'
// import {   shop_get } from '@/api/mall'
import {  list,shop_set,shop_get } from '@/api/admin/shop'
import { useShopStore } from '@/store/modules/shopms'
import File from './file.vue'
import Tabs from './tabs.vue' // 导入标签页组件
import {
  Shop,
  ArrowDown,
  Check,
  SwitchButton,
  Monitor
} from '@element-plus/icons-vue'

const router = useRouter()
const userStore = useUserStore()
const shopDropdown = ref(null)
const dropdownVisible = ref(false)
const ShopStore = useShopStore();
const visible = ref(false)

// 用户信息
const nickname = ref(userStore.user?.nickname || '未登录')
const userAvatar = computed(() => userStore.user?.avatar_url || 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png')

// 商城数据
const shopList = ref([])
const currentShopId = ref()

// 后台数据 - 使用假数据
const adminList = ref([
  { id:1, name: '主后台系统' },
  { id:2, name: '城市仓系统' },
])

const currentShopName = computed(() => {
  const shop = shopList.value.find(shop => shop.id === currentShopId.value)
  return shop ? shop.name : '未选择'
})

const currentAdminName = computed(() => {
  const admin = adminList.value.find(a => a.id === userStore.user.systemid)
  return admin ? admin.name : '后台'
})

const getShopList = async () => {

  console.log('systemid',nickname.value)

  if (nickname.value=='超级管理员'){
    const res = await list()

    console.log('getShopList', res.data)

    shopList.value = res?.data
    const con = await shop_get()

    console.log('con', con)

    currentShopId.value = Number(con.data)
  }


}

// 切换商城
const handleSwitchShop = async (shopId) => {
  try {
    currentShopId.value = shopId;

    console.log('shopId',shopId)

    await shop_set({ shop_id: shopId });




    shopDropdown.value?.handleClose();
    ShopStore.setadmin(shopId)
    ElMessage({
      type:'success',
      message:`已切换到: ${currentShopName.value}`,
      duration:2000,
    })




  } catch (error) {
    ElMessage.error('切换失败');
    console.error('切换商城错误:', error);
  }
}

// 切换后台
const handleAdminSwitch = async (adminId) => {
  try {
    await userStore.setadmin(adminId);
    shopDropdown.value?.handleClose();
    const adminName = adminList.value.find(a => a.id === adminId)?.name || '';
    let url = '';
    switch(adminId){
      case 1:
         url = userStore.user.rule.routesadmin[0].path;
        break;
      case 2:
         url = userStore.user.rule.routes[0].path;
        break;
    }


    router.replace(url)
    ElMessage({
      type:'success',
      message:`已切换到: ${adminName}`,
      duration:2000,
    })
  } catch (error) {
    ElMessage.error('切换失败');
    console.error('切换后台错误:', error);
  }
}

// 控制下拉菜单显示状态
const handleDropdownVisible = (visible) => {
  dropdownVisible.value = visible
}

// 用户菜单操作
const handleCommand = (command) => {
  switch(command) {
    case 'logout':
      logout()
      break
  }
}

// 退出登录
const logout = async () => {
    await userStore.logout()
}

// 跳转首页
const toIndex = () => {
  router.push('/')
}

// 生命周期钩子
onMounted(() => {
  getShopList()
  // shop_get()
})

</script>

<style scoped>
.header-container {
  display: flex;
  align-items: center;
  height: 50px;
  padding: 0 12px;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
  position: relative;
  z-index: 10;
}

.header-title {
  display: flex;
  align-items: center;
  font-size: 16px;
  font-weight: 600;
  min-width: 220px;
  color: #333;
  cursor: pointer;
  white-space: nowrap;
}

.header-logo {
  height: 40px;
  margin-right: 8px;
}

.title-text {
  white-space: nowrap;
}

.header-actions {
  display: flex;
  align-items: center;
  margin-left: auto;
  gap: 12px;
}

/* 商城切换器 */
.shop-trigger {
  display: flex;
  align-items: center;
  padding: 0 8px;
  height: 28px;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  font-size: 12px;
  gap: 6px;
}

.shop-trigger:hover {
  background: #f1f5f9;
  border-color: #cbd5e1;
}

.shop-icon {
  color: #3b82f6;
  font-size: 14px;
}

.shop-name {
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
}

/* 后台切换器 */
.admin-switcher {
  margin-left: 0;
}

.admin-trigger {
  display: flex;
  align-items: center;
  padding: 0 8px;
  height: 28px;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s;
  background: #f9f0ff;
  border: 1px solid #e9d8fd;
  font-size: 12px;
  gap: 6px;
}

.admin-trigger:hover {
  background: #f3e8ff;
  border-color: #d6bcfa;
}

.admin-icon {
  color: #9f7aea;
  font-size: 14px;
}

.admin-name {
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
}

.arrow-icon {
  color: #94a3b8;
  font-size: 12px;
  transition: transform 0.2s;
}

.rotate {
  transform: rotate(180deg);
}

/* 用户菜单 */
.user-dropdown {
  cursor: pointer;
  margin-left: 0;
}

.user-trigger {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 0 8px;
  height: 28px;
  border-radius: 4px;
  transition: all 0.2s;
}

.user-trigger:hover {
  background: #f1f5f9;
}

.user-avatar {
  background-color: #e2e8f0;
}

.user-name {
  font-size: 12px;
  font-weight: 500;
  color: #1e293b;
  max-width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dropdown-icon {
  color: #94a3b8;
  font-size: 12px;
}

/* 下载中心 */
.download-center {
  display: flex;
  align-items: center;
  padding: 0 8px;
  height: 28px;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s;
  font-size: 12px;
  gap: 4px;
}

.download-center:hover {
  background: #f1f5f9;
  color: var(--el-color-primary);
}

.download-icon {
  font-size: 14px;
}

.download-text {
  font-size: 12px;
}
</style>

<style>
.shop-dropdown-popper {
  .shop-dropdown-menu {
    padding: 4px 0 !important;
    max-height: 300px;
    overflow-y: auto;
    width: 200px;

    .el-dropdown-menu__item {
      padding: 6px 12px !important;
      line-height: 1.4;
      font-size: 12px;

      &:hover, &.active-shop {
        background-color: #f5f7fa !important;
        color: #3b82f6 !important;

        .shop-item-name {
          color: #3b82f6 !important;
        }
      }

      &.active-shop {
        background-color: #ecf5ff !important;
      }
    }
  }
}

.admin-dropdown-menu {
  min-width: 150px;

  .el-dropdown-menu__item {
    padding: 6px 12px !important;
    font-size: 12px;

    &:hover, &.active-admin {
      background-color: #f5f3ff !important;
      color: #8b5cf6 !important;

      .check-icon {
        color: #8b5cf6 !important;
      }
    }

    &.active-admin {
      background-color: #f3e8ff !important;
    }
  }
}
</style>
